import mitt from "mitt";
const eventBus = mitt();

export function openModal(contentType, title) {
  eventBus.emit("open-modal", { contentType, title });
}
export default eventBus;
